<agr-dialog
  [ngClass]="
    (groupedTreatments$ | async)?.length && !isOnMobile
      ? 'adjust-sprays-dialog-with-gbm-treatments'
      : 'adjust-sprays-dialog'
  "
  [data]="data"
  [verticalSpacing]="true"
  [contentSpacing]="true"
  (cancel)="cancel()"
>
  <ng-container *ngrxLet="groupedTreatments$ as groupedTreatments">
    <div [ngClass]="{ 'two-column-layout': groupedTreatments.length }">
      @if (groupedTreatments?.length && !isOnMobile) {
        <div class="left-column">
          <div class="notification notification-warning" style="font-size: 13px">
            <mat-icon>warning</mat-icon>
            <strong class="text--warning" [innerHTML]="'gbmWarningTitle' | translate"></strong>
            <br />
            <span [innerHTML]="'gbmWarningDescription2' | translate"></span>
          </div>
          <div class="advices-tables">
            <div class="adviced-treatments-table">
              <p class="table-title spacing--margin-vertical">
                <strong>{{ 'blight.sprays.advicedTreatmentsTableTitle' | translate }}</strong>
              </p>
              @for (group of groupedTreatments; track group.cropFieldId) {
                <span class="spacing--margin-vertical">
                  <span class="text--bold"> {{ 'cropField' | translate }}</span> {{ group.cropFieldName }}
                </span>
                <ng-container>
                  <mat-table
                    [dataSource]="filterGBMTreatmentsWithPhytophthora(group.treatments)"
                    class="table-wrapper spacing--margin-bottom"
                  >
                    <ng-container matColumnDef="name">
                      <mat-header-cell *matHeaderCellDef class="flex__child--3">
                        <div class="text--right spacing--margin-right">
                          <span>{{ 'treatment' | translate }}</span>
                        </div>
                      </mat-header-cell>
                      <mat-cell *matCellDef="let treatment" class="flex__child--3">
                        <span>{{ treatment.name }}</span>
                      </mat-cell>
                    </ng-container>
                    <ng-container matColumnDef="objective">
                      <mat-header-cell *matHeaderCellDef class="flex__child--1">
                        <div class="text--right spacing--margin-right">
                          <span>{{ 'objective' | translate }}</span>
                        </div>
                      </mat-header-cell>
                      <mat-cell *matCellDef="let treatment" class="flex__child--1">
                        <span>{{ treatment.objective | translate }}</span>
                      </mat-cell>
                    </ng-container>
                    <ng-container matColumnDef="frequency">
                      <mat-header-cell *matHeaderCellDef class="flex__child--2">
                        <div class="text--right spacing--margin-right">
                          <span>{{ 'frequency' | translate }}</span>
                        </div>
                      </mat-header-cell>
                      <mat-cell *matCellDef="let treatment" class="flex__child--2">
                        <span>{{ treatment.frequency }}</span>
                      </mat-cell>
                    </ng-container>
                    <mat-header-row
                      *matHeaderRowDef="['name', 'objective', 'frequency']"
                      [class.mat-header-row-sticky]="true"
                    >
                    </mat-header-row>
                    <mat-row *matRowDef="let row; columns: ['name', 'objective', 'frequency']"></mat-row>
                  </mat-table>
                </ng-container>
              }
            </div>
          </div>
        </div>
      }

      <div [ngClass]="{ 'right-column': groupedTreatments.length }">
        <div [formGroup]="form">
          <ng-container details *ngrxLet="selectedCropFields$ as cropFields">
            <div class="flex--row">
              <div class="spacing--margin-right">
                <mat-chip-listbox>
                  @for (cropField of cropFields; track cropField.id) {
                    <mat-chip-option
                      [selectable]="false"
                      [removable]="cropFields.length > 1 && !data.readOnly"
                      (removed)="removeCropField(cropField.id)"
                    >
                      <b>{{ cropField.name }}</b> {{ cropField.areaInHectares }} ha
                      @if (cropFields.length > 1 && !data.readOnly) {
                        <mat-icon matChipRemove data-test="crop-remove">cancel</mat-icon>
                      }
                    </mat-chip-option>
                  }
                </mat-chip-listbox>
              </div>
            </div>
          </ng-container>
          <div class="spacing--margin-half-top input-container">
            <mat-form-field class="date-field" data-test="blight-sprayDialog-date">
              <mat-label>{{ 'blight.date' | translate }}</mat-label>
              <input
                matInput
                formControlName="date"
                [matDatepicker]="sprayDatePicker"
                [placeholder]="'blight.date' | translate"
                [min]="cropEmergenceDate"
                [max]="maxSprayDate"
                [disabled]="cropEmergenceDate === null || data.readOnly"
              />
              <mat-datepicker-toggle
                matSuffix
                [for]="sprayDatePicker"
                [disabled]="data.readOnly"
              ></mat-datepicker-toggle>
              <mat-datepicker #sprayDatePicker></mat-datepicker>
            </mat-form-field>
            <mat-form-field class="time-field">
              <mat-label>{{ 'blight.time' | translate }}</mat-label>
              <mat-select formControlName="time">
                @for (hour of hours; track hour) {
                  <mat-option [value]="hour">
                    @if (hour < 10) {
                      <span>0</span>
                    }
                    {{ hour }}:00
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
          <div class="flex__child--auto flex--gutter flex--nowrap">
            <div class="flex__child--auto">
              <mat-form-field class="full-width-field" subscriptSizing="dynamic">
                @if (data.sprayType === 1) {
                  <mat-label>{{ 'treatments-type-1' | translate }}</mat-label>
                }
                @if (data.sprayType === 2) {
                  <mat-label>{{ 'treatments-type-2' | translate }}</mat-label>
                }
                @if (data.sprayType === 3) {
                  <mat-label>{{ 'treatments-type-3' | translate }}</mat-label>
                }
                @if (!data.sprayType) {
                  <mat-label>{{ 'treatments' | translate }}</mat-label>
                }

                <input
                  type="text"
                  [placeholder]="getBasicSprayDisplayValue(selectedTreatment)"
                  matInput
                  formControlName="treatment"
                  [matAutocomplete]="sprayAutoComplete"
                  appClearOnFocus
                />
                <mat-autocomplete
                  (optionSelected)="selectedTreatment = $event.option.value"
                  #sprayAutoComplete="matAutocomplete"
                  [displayWith]="getBasicSprayDisplayValue"
                  [panelWidth]="'auto'"
                >
                  @for (spray of spraysMatchingSearchQuery$ | async; track spray) {
                    <mat-option [value]="spray">{{ getBasicSprayDisplayValue(spray) }}</mat-option>
                  }
                </mat-autocomplete>
              </mat-form-field>
            </div>
          </div>
          <span [matTooltip]="'UI.CurrentYearOnlyMutationMessage' | translate" [matTooltipDisabled]="!data.readOnly">
            <button
              mat-flat-button
              color="accent"
              data-test="done-adding-product"
              type="button"
              (click)="addSprayApplication()"
              [disabled]="isAddSprayDisabled$ | async"
              class="spacing--margin-top spacing--margin-half-right"
            >
              @if (isAnyCropFieldRecalculating$ | async) {
                <mat-icon class="loading">autorenew</mat-icon>
              }
              <mat-icon>add</mat-icon>
              {{ 'add' | translate }}
            </button>
          </span>
          @if (data.readOnly) {
            <div class="notification notification-info spacing--margin-top spacing--margin-bottom">
              <mat-icon>info</mat-icon>
              {{ fmsReadonlyMessageKey | translate }}
            </div>
          }
          @if (form.controls['treatment'].value) {
            <mat-card
              appearance="outlined"
              class="flex--row spacing--margin-half-bottom info-card"
              [ngClass]="!isOnMobile && (gbmTreatments?.length ?? 0) > 0 ? 'spacing--margin-left' : null"
            >
            </mat-card>
          }
          @if (form.controls.treatment.value && (hasExistingSprayForDate$ | async)) {
            <mat-card
              appearance="outlined"
              class="flex--row spacing--margin-half-bottom info-card one-day-warning"
              [ngStyle]="{ width: !isOnMobile && gbmTreatments && gbmTreatments.length > 0 ? '551px' : '' }"
            >
              <mat-card-content class="info-card-content">
                <div class="icon-container">
                  <mat-icon>warning</mat-icon>
                </div>
                <b>
                  <span class="info-message">
                    {{ 'blight.sprays.oneSprayPerDayErrorMessage' | translate }}
                  </span>
                </b>
              </mat-card-content>
            </mat-card>
          }
          <ng-container>
            @if (isAnyCropFieldRecalculating$ | async) {
              <div class="notification notification-info text--input-small">
                <mat-icon class="spacing--margin-right">info</mat-icon>
                {{ 'blight.blightDetail.recalculatingAdvice' | translate }}
              </div>
            }
          </ng-container>
        </div>
        <div class="text--bold spacing--margin-vertical">
          {{ 'blight.spraysTableTitle' | translate }}
        </div>
        @if (groupedSprays$ | async; as groupedSprays) {
          <ng-container class="spray-table">
            @for (group of groupedSprays; track group) {
              <div class="spacing--margin-bottom">
                <b>{{ 'cropField' | translate }}</b> {{ group.cropFieldName }}
                <mat-table class="table-wrapper" [dataSource]="group.sprays" data-test="spray-applications-table">
                  <ng-container matColumnDef="date">
                    <mat-header-cell *matHeaderCellDef class="flex__child flex__child-4 flex">
                      <div class="text--right spacing--margin-right">
                        <span>
                          {{ 'blight.date' | translate }}
                        </span>
                      </div>
                    </mat-header-cell>
                    <mat-cell *matCellDef="let spray" class="flex__child flex__child-4">
                      <span>{{ spray.sprayedOn | date: 'shortDate' : 'UTC' : locale }}</span>
                    </mat-cell>
                  </ng-container>
                  <ng-container matColumnDef="time">
                    <mat-header-cell *matHeaderCellDef class="flex__child flex__child-4 flex">
                      <div class="text--right spacing--margin-right">
                        <span>
                          {{ 'blight.time' | translate }}
                        </span>
                      </div>
                    </mat-header-cell>
                    <mat-cell *matCellDef="let spray" class="flex__child flex__child-4">
                      <span>{{ spray.sprayedOn | date: 'shortTime' : 'UTC' : locale }}</span>
                    </mat-cell>
                  </ng-container>
                  <ng-container matColumnDef="sprayNumber">
                    <mat-header-cell *matHeaderCellDef class="flex__child flex__child-4 flex">
                      <div class="text--right spacing--margin-right">
                        <span>
                          {{ 'blight.sprayNumber' | translate }}
                        </span>
                      </div>
                    </mat-header-cell>
                    <mat-cell *matCellDef="let spray; let i = index" class="flex__child flex__child-4">
                      <span>{{ spray.sprayIndex }}</span>
                    </mat-cell>
                  </ng-container>
                  <ng-container matColumnDef="fungicide">
                    <mat-header-cell *matHeaderCellDef class="flex__child flex__child-4 flex">
                      <div class="text--right spacing--margin-right">
                        <span>
                          {{ 'blight.fungicides' | translate }}
                        </span>
                      </div>
                    </mat-header-cell>
                    <mat-cell *matCellDef="let spray" class="flex__child flex__child-4">
                      <span>{{ spray.name }}</span>
                    </mat-cell>
                  </ng-container>
                  <ng-container matColumnDef="actions">
                    <mat-header-cell *matHeaderCellDef class="flex__child flex__child-4 flex"> </mat-header-cell>
                    <mat-cell *matCellDef="let spray" class="flex__child flex__child-4">
                      <button mat-icon-button (click)="this.deleteSprayApplication(spray, group.cropFieldId)">
                        <mat-icon>delete</mat-icon>
                      </button>
                    </mat-cell>
                  </ng-container>
                  <mat-header-row *matHeaderRowDef="sprayHistoryColumns"></mat-header-row>
                  <mat-row *matRowDef="let row; columns: sprayHistoryColumns"></mat-row>
                </mat-table>
              </div>
            }
          </ng-container>
        }
        @if (isSpraysLoading$ | async) {
          <mat-spinner class="spinner"></mat-spinner>
        }
      </div>
    </div>
  </ng-container>
</agr-dialog>

<ng-template #deleteColumn let-row="row" let-column="column"> </ng-template>
